import React from 'react';
import { Wrapper, Loader, TLoaderSize } from './HBLoader.styles';
import { vars } from '../../theme';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';
import { useBuildTestIdInternal } from '../../hooks/useBuildTestIdInternal';
export interface Props {
    /** Loader diameter variant: 'xxs' (12px), 'xs' (16px), 'small' (24px), 'medium' (40px), 'large' (80px). */
    size?: TLoaderSize;
    /** CSS class forwarded to the outer wrapper element. */
    className?: string;
    /** Color applied to three of the four border segments. Accepts any CSS color value; defaults to neutral900 (dark gray). */
    color?: string;
    /** When false (default), the loader is absolutely centered in its positioned parent; when true, it flows inline with surrounding content. */
    inline?: boolean;
}

const HBLoader = ({
    size = 'xs',
    className,
    color = vars.colors.text.primary,
    testIdName,
    inline,
    testId
}: Props & MustIncludeOneOfBasicTestIdProps) => {
    const finalTestId = useBuildTestIdInternal({
        testId,
        identifier: testIdName,
        suffix: 'loader',
        componentName: 'HBLoader'
    });

    return (
        <Wrapper
            className={className}
            data-testid={finalTestId}
            floatCenter={!inline}
        >
            <Loader size={size} color={color} data-testid="loader" />
        </Wrapper>
    );
};

export default HBLoader;
